import React from 'react';
import { Link } from 'react-router-dom';
import './Industries.css';
import placeholderImage from '../assets/placeholder-image.png';

const Industries: React.FC = () => {
  return (
    <div className="industries-page">
      {/* Revolutionary Hero Section */}
      <section className="industries-hero-section">
        <div className="hero-background">
          <div className="hero-gradient-overlay"></div>
          <div className="hero-particles"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge-container">
              <div className="hero-badge">
                <span className="badge-icon">⚡</span>
                <span>CUTTING EDGE SOLUTIONS</span>
              </div>
            </div>
            <h1 className="hero-title">
              <span className="title-highlight">Financial Intelligence</span>
              <br />
              Tailored to Your Industry
            </h1>
            <p className="hero-subtitle">
              Revolutionize your credit decisioning with cutting-edge graph technology. 
              Our platform transforms data into actionable insights across multiple industries, 
              delivering results that matter.
            </p>
            
            {/* Hero Stats */}
            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
                  </svg>
                </div>
                <div className="stat-content">
                  <div className="stat-value">LOWER</div>
                  <div className="stat-label">Credit Losses</div>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="stat-content">
                  <div className="stat-value">FEWER</div>
                  <div className="stat-label">Manual Reviews</div>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" fill="currentColor"/>
                  </svg>
                </div>
                <div className="stat-content">
                  <div className="stat-value">FAST</div>
                  <div className="stat-label">Processing</div>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 17L12 22L22 17M2 12L12 17L22 12M12 2L22 7L12 12L2 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="stat-content">
                  <div className="stat-value">INCREASE</div>
                  <div className="stat-label">Sales</div>
                </div>
              </div>
            </div>
            
            
          </div>
          
          {/* Dynamic Visual Element */}
          
        </div>
        <div className="hero-pattern"></div>
      </section>

      {/* Enhanced Industry Solutions Section */}
      <section className="industry-solutions-section">
        <div className="container">
          <div className="section-header">
            <div className="section-badge">
              <span className="badge-icon">🎯</span>
              <span>OPTIMIZED SOLUTION</span>
            </div>
            <h2 className="section-title">Industry-Specific Solutions That Deliver Results</h2>
            <p className="section-subtitle">
              Our graph intelligence platform has been optimized for the unique challenges 
              and opportunities within these key industries, delivering measurable improvements 
              in risk assessment and operational efficiency.
            </p>
          </div>
          
          <div className="industries-showcase">
            <div className="industry-card">
              <div className="card-background-pattern"></div>
              <div className="card-header">
                <div className="card-icon-wrapper">
                  <div className="card-icon">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 10V8H20V10H4Z" fill="currentColor"/>
                      <path d="M2 7C2 6.44772 2.44772 6 3 6H21C21.5523 6 22 6.44772 22 7V17C22 17.5523 21.5523 18 21 18H3C2.44772 18 2 17.5523 2 17V7Z" stroke="currentColor" strokeWidth="2"/>
                      <path d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" fill="currentColor"/>
                    </svg>
                  </div>
                </div>
                <h3>Banking & Credit Assessment</h3>
                <div className="card-metrics">
                </div>
              </div>
              <div className="card-content">
                <p>Transform your credit decisioning with advanced graph intelligence that reveals hidden relationships between entities, improving risk classification while streamlining operational workflows and reducing manual reviews.</p>
                
                <div className="card-features">
                  <div className="feature-item">
                    <svg viewBox="0 0 16 16" className="feature-icon">
                      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                    </svg>
                    <span>Improved credit decisioning</span>
                  </div>
                  <div className="feature-item">
                    <svg viewBox="0 0 16 16" className="feature-icon">
                      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                    </svg>
                    <span>Complex business network visualization</span>
                  </div>
                  <div className="feature-item">
                    <svg viewBox="0 0 16 16" className="feature-icon">
                      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                    </svg>
                    <span>Simplified operational workflows</span>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <Link to="/contact?demo=true" className="card-button primary">
                  <span>Request Demo</span>
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Link>
              </div>
            </div>
            
            <div className="industry-card">
              <div className="card-background-pattern"></div>
              <div className="card-header">
                <div className="card-icon-wrapper">
                  <div className="card-icon">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6Z" stroke="currentColor" strokeWidth="2"/>
                      <path d="M12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15Z" stroke="currentColor" strokeWidth="2"/>
                      <path d="M6 11H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M16 11H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
                <h3>E-commerce</h3>
              </div>
              <div className="card-content">
                <p>Enhance your existing credit assessment system with our solution that can reduce credit losses and manual reviews without sacrificing approval rates, specifically designed for B2B E-commerce.</p>
                
                <div className="card-features">
                  <div className="feature-item">
                    <svg viewBox="0 0 16 16" className="feature-icon">
                      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                    </svg>
                    <span>Reduced credit losses</span>
                  </div>
                  <div className="feature-item">
                    <svg viewBox="0 0 16 16" className="feature-icon">
                      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                    </svg>
                    <span>Decreased manual reviews</span>
                  </div>
                  <div className="feature-item">
                    <svg viewBox="0 0 16 16" className="feature-icon">
                      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                    </svg>
                    <span>Easy integration</span>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <Link to="/contact?demo=true" className="card-button primary">
                  <span>Request Demo</span>
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      
    </div>
  );
};

export default Industries;
